/**
 * HELPERS
 */

function getScrollPos() {
	return {
		"scrollTop" : (document.documentElement.scrollTop || document.body.scrollTop),
		"scrollLeft" : (document.documentElement.scrollLeft || document.body.scrollLeft)
	};
}

// shim layer with setTimeout fallback
window.requestAnimFrame = (function(){
	return  window.requestAnimationFrame ||
	window.webkitRequestAnimationFrame   ||
	window.mozRequestAnimationFrame      ||
	function( callback ){
		window.setTimeout(callback, 1000 / 60);
	};
})();

function prefix(obj, prop, value) {
  // console.log(obj, prop, value);
  var prefs = ['webkit', 'Moz', 'o', 'ms'];
  for (var pref in prefs) {
    obj.style[prefs[pref] + prop.capitalizeFirstLetter()] = value;
  }
}

String.prototype.capitalizeFirstLetter = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

function closest(el, selector) {
    var matchesFn;

    // find vendor prefix
    ['matches','webkitMatchesSelector','mozMatchesSelector','msMatchesSelector','oMatchesSelector'].some(function(fn) {
        if (typeof document.body[fn] == 'function') {
            matchesFn = fn;
            return true;
        }
        return false;
    });

    var parent;

    // traverse parents
    while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
            return parent;
        }
        el = parent;
    }

    return null;
}

/**
 * http://davidshariff.com/blog/javascript-inheritance-patterns/
 * Create a new constructor function, whose prototype is the parent object's prototype.
 * Set the child's prototype to the newly created constructor function.
 **/
var extendObj = function(childObj, parentObj) {
    var tmpObj = function () {};
    tmpObj.prototype = parentObj.prototype;
    childObj.prototype = new tmpObj();
    childObj.prototype.constructor = childObj;
};

/*
 * DW Namespace init
 */

var DW = DW || {};

//+++++++++++++++++++++++++++++++++++++++++++++++
// ACCORDIONS
//+++++++++++++++++++++++++++++++++++++++++++++++
// This class helps toggling content accordions
// visible
//+++++++++++++++++++++++++++++++++++++++++++++++

DW.Accordion = function(accordion, accordionBody, toggleLink, toggleCloseLink) {
  this.accordion = accordion;
  this.accordionBody = accordionBody;
  this.toggleLink = toggleLink;
  this.toggleCloseLink = toggleCloseLink;
  this.accordion.classList.add("accordion--init");
  this.toggleLink.addEventListener('click', this.toggleAccordion.bind(this));
  this.toggleCloseLink.addEventListener('click', this.toggleAccordion.bind(this));
  this.animationDuration = 500;

  this.blockParent = closest(this.accordion, '.block');
  this.blockParent.classList.add('accordion-parent');
};

DW.Accordion.prototype = {
  toggleAccordion : function(ev) {
    ev.preventDefault();
    this.toggleLink.blur();

    // Check if other accordion is currently open
    var closeOtherAccordion = document.querySelector(".accordion.accordion--active");
    if(closeOtherAccordion && closeOtherAccordion != this.accordion) {
      closeOtherAccordion.classList.remove('accordion--active');
    }

    this.animateAccordion();
  },

  animateAccordion : function() {
    var to,
    start,
    callback = null,
    fps = 60,
    change,
    increment = 1000 / fps,
    elem = this.accordionBody;
    if(this.accordion.classList.contains('accordion--active')) {

      // Animate from height to zero, than remove display block class
      start = parseInt(this.accordionBody.style.height);
      to = 0;
      callback = function() {
        this.accordionBody.style.height = '';
        this.accordion.classList.remove('accordion--active');
      }.bind(this);
    } else {

      // Add display block class, than animate from zero to height
      this.accordion.classList.add('accordion--active');
      start = 0;
      to = this.accordionBody.offsetHeight;
      this.accordionBody.style.height = start;
    }

    change = to - start;

    var doOnIncrement = function(val) {
      elem.style.height = val + 'px';
    };

    var animate = new DW.Animate(this.animationDuration, increment, '', start, change, doOnIncrement, callback);
  }
};


DW.MainMenu = function(menu, menuToggles) {
	this.menu = menu;
	this.menuToggles = [].slice.call(menuToggles);
	this.visible = false;
	this.burgerButtons = [];

	this.menuToggles.forEach(function(menuToggle){
		this.burgerButtons.push(menuToggle.querySelector('.burger'));
		menuToggle.addEventListener('click', this.toggleMenu.bind(this));
	}.bind(this));
};

DW.MainMenu.prototype.toggleMenu = function(ev) {
	ev.preventDefault();
	var i;
	this.visible = !this.visible;
	this.menu.classList.toggle('menu--active');
	this.burgerButtons.forEach(function(burgerButton) {
		burgerButton.classList.toggle('burger--active');
	});
};

DW.ContactMenu = function(menu, menuToggles) {
	this.menu = menu;
	this.menuToggles = [].slice.call(menuToggles);
	var i;

	this.menuToggles.forEach(function(menuToggle) {
		menuToggle.addEventListener('click', this.toggleMenu.bind(this));
	}.bind(this));
};

DW.ContactMenu.prototype.toggleMenu = function(ev) {
	ev.preventDefault();
	this.menu.classList.toggle('active');
	this.menuToggles.forEach(function(menuToggle) {
		menuToggle.classList.toggle('active');
	});
};

DW.CookieBar = function(bar, barHide) {
    this.bar = bar;
    this.barHide = barHide;
    
    barHide.addEventListener('click', this.hideBar.bind(this));

    if (Cookies.get('cookiesAccepted') !== '1') {
        bar.classList.add('active');
    }
};

DW.CookieBar.prototype.hideBar = function(ev) {
    ev.preventDefault();
    this.bar.classList.remove('active');
    Cookies.set('cookiesAccepted', '1');
};

// Base Class for all items that need to be animated on scroll

DW.ScrollAnimationItem = function(container) {
	this.container = container;
};

DW.ScrollAnimationItem.prototype = {
	inVerticalView : function(scrollTop, windowHeight) {
		var rect = this.container.getBoundingClientRect();
		return (rect.top < window.innerHeight && rect.bottom > 0);
	},

	belowView : function(scrollTop, windowHeight) {
		var rect = this.container.getBoundingClientRect();
		return (scrollTop + windowHeight) < rect.top;
	},

	animateWhileInView : function() {
		this.container.classList.add('animated');
	},

	resetAnimation : function() {
		this.container.classList.remove('animated');
	},
};


DW.TimelineElement = function(container) {
	this.container = container;
	this.image = container.querySelector("img");
};

// Extend ScrollAnimation Item
extendObj(DW.TimelineElement, DW.ScrollAnimationItem);

DW.TimelineElement.prototype.animateWhileInView = function(scrollPos, height) {

	// Only on larger screens
	if(window.matchMedia("(min-width: 48em)").matches) {
		var ratioScrolled;
		var rect = this.container.getBoundingClientRect();
		var rectHeight = this.container.offsetHeight;
		var heightHalf = ((rect.bottom - rect.top) / 2);
		var scaleMaxFactor = 1.1;
		var scaleChangeFactor = 0.5;
		// console.log("Full scroll", (height - rect.top) / height);
		// console.log("Half scroll", (height - rect.top) / (height / 2));

		// console.log(rectHeight);
		if(rect.top + heightHalf > height / 2) {
			// lower half

			ratioScrolled = Math.min(1, (height - rect.top - heightHalf) / (height / 2));
			prefix(this.container, 'transform', 'scale(' + (scaleMaxFactor - (scaleChangeFactor - scaleChangeFactor * ratioScrolled)) + ')');
		} else {

			ratioScrolled = Math.min(1, ((height - rect.top - heightHalf) / (height / 2) - 1));
			prefix(this.container, 'transform', 'scale(' + (scaleMaxFactor - scaleChangeFactor * ratioScrolled) + ')');
		}
	} else {
		prefix(this.container, 'transform', 'scale(1)');
	}
};

// Keeps track of SVG Elements, animates them, resets them, etc ...


// Extend ScrollAnimation Item
DW.SVGAnimationElement = function(container) {
	this.container = container;
	this.svg = this.container.querySelector('svg');
	this.snap = Snap(this.svg);
	this.pathToAnimate = this.snap.select('.start-path');
	this.startPath = this.container.querySelector('.start-path').getAttribute('d');
	this.endPath = this.container.querySelector('.end-path').getAttribute('d');
	this.animating = false; // Keeps track, if animation is active
	this.animated = false; // Keeps track if element was already animated
};

extendObj(DW.SVGAnimationElement, DW.ScrollAnimationItem);

DW.SVGAnimationElement.prototype.animateWhileInView = function() {
	if(!this.animating && !this.animated) {
		this.animating = true;
		this.pathToAnimate.animate({
			d: this.endPath
		}, 500, mina.easeinout, function() {
			this.animating = false;
			this.animated = true;
		}.bind(this));
	}
};


DW.SVGAnimationElement.prototype.resetAnimation = function() {
	if(this.animated) {
		this.pathToAnimate.node.setAttribute('d', this.startPath);
		this.animated = false;
	}
};

//=require DW.TimelineItem.js

/*
 * This class checks if something should happen on scroll
 */
DW.ScrollEvents = function(svgAnimationElements, timelineElements, blockElements, banner) {
	this.scrolled = true;
	this.width = window.innerWidth;
	this.height = window.innerHeight;
	this.contentLoaded = false;

	// Create array of background images, that have nice methods to get scroll Infos
	this.svgAnimationElements = [];
	[].slice.call(svgAnimationElements).forEach(function(elem) {
		this.svgAnimationElements.push(new DW.SVGAnimationElement(elem));
	}.bind(this));

	this.timelineElements = [];
	[].slice.call(timelineElements).forEach(function(elem){
		this.timelineElements.push(new DW.TimelineElement(elem));
	}.bind(this));

	this.blockElements = [];
	[].slice.call(blockElements).forEach(function(elem){
		this.blockElements.push(new DW.ScrollAnimationItem(elem));
	}.bind(this));

	// Combine arrays that need same checks
	this.checkInVerticalView = this.svgAnimationElements.concat(this.timelineElements).concat(this.blockElements);
	this.checkBelowView = this.svgAnimationElements.concat(this.blockElements);

	this.banner = new DW.ScrollAnimationItem(banner);

	// scroll Logic happens inside request animation frame for better performance. window.onscroll only tells me, if a scroll occured
	window.addEventListener('scroll', function(ev) {
		if(this.scrolled === false) {
			this.scrolled = true;
			window.requestAnimFrame(this.checkScroll.bind(this));
		}
	}.bind(this));

	// Resize Event
	window.addEventListener('resize', function(ev) {
		this.width = window.innerWidth;
		this.height = window.innerHeight;
	}.bind(this));

	// initial checkScroll happens on load
};

DW.ScrollEvents.prototype = {
	initOnLoad: function() {
		this.contentLoaded = true;
		this.checkScroll();
	},

	checkScroll: function(ev) {
		if(this.contentLoaded === true) {
			scrollPos = getScrollPos();

			// Filter all elements that are in view and animate them
			var imagesInView = this.checkInVerticalView.filter(function(elem) {
				return elem.inVerticalView(scrollPos.scrollTop, this.height);
			}, this);
			imagesInView.forEach(function(elem) {
				elem.animateWhileInView(scrollPos.scrollTop, this.height);
			}.bind(this));

			// Filter all elements that are below view and reset them, if needed
			var imagesBelowView = this.checkBelowView.filter(function(elem) {
				return elem.belowView(scrollPos.scrollTop, this.height);
			}, this);
			imagesBelowView.forEach(function(elem) {
				elem.resetAnimation();
			}.bind(this));

			// Check if banner (main-header) is currently visible, mainly used for
			// section navigation
			if(this.banner.inVerticalView(scrollPos.scrollTop, this.height)) {
				document.body.classList.add("banner-visible");
			} else {
				document.body.classList.remove("banner-visible");
			}

			this.scrolled = false;
		}
	}
};

//+++++++++++++++++++++++++++++++++++++++++++++++
// ANIMATION
//+++++++++++++++++++++++++++++++++++++++++++++++
// Different functions and classes, that deal
// with js animation. Default Easing is
// easeInOutQuad
//+++++++++++++++++++++++++++++++++++++++++++++++

DW.Animate = function(duration, increment, easing, start, change, doOnIncrement, callback) {

  duration = (parseInt(duration) > 0) ? parseInt(duration) : 500;
  easing = (easing !== '') ? easing : 'easeInOutQuad';
  var currentTime = 0;
  var loop = function() {
    currentTime += increment;
    var easingFunctions = new DW.EasingFunctions();
    var val = easingFunctions[easing](currentTime, start, change, duration);
    // var val = EasingFunctions.easeOutBounce(currentTime, start, change, duration);
    if(doOnIncrement && typeof(doOnIncrement) === 'function') {
      doOnIncrement(val);
    }
    if(currentTime < duration) {
      setTimeout(function() {
        loop();
      }, increment);
    } else {
      if(callback && typeof(callback) === 'function') {
        callback();
      }
    }
  };

  loop();
};

//+++++++++++++++++++++++++++++++++++++++++++++++
// EASING FUNCTIONS
//+++++++++++++++++++++++++++++++++++++++++++++++
// All easing functions of https://goo.gl/N2rHTv
// have been adapted to vanilla js extensions of
// the CC.EasingFunctions Namespace. They can be
// easily used by requiring this file and the
// required easing function in the
// easing-functions folder
//+++++++++++++++++++++++++++++++++++++++++++++++

DW.EasingFunctions = function() {
};

DW.EasingFunctions.prototype.easeInOutQuad = function(time, beginning, end, duration) {
  if((time/=duration/2) < 1) return end / 2 * time * time + beginning;
  return -end/2 * ((--time) * (time - 2) - 1) + beginning;
};


//+++++++++++++++++++++++++++++++++++++++++++++++
// SCROLL TO
//+++++++++++++++++++++++++++++++++++++++++++++++
// JS Scroll To functionality. Can be used
// for scroll top etc.
//+++++++++++++++++++++++++++++++++++++++++++++++

DW.scrollTo = function(to, callback, duration) {
  // because it's so fucking difficult to detect the scrolling element, just move them all
  function move(amount) {
    document.documentElement.scrollTop = amount;
    document.body.parentNode.scrollTop = amount;
    document.body.scrollTop = amount;
  }

  function position() {
    return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
  }

  var fps = 60;
  var increment = 1000 / fps;

  var animate = new DW.Animate(duration, 1000 / fps, 'easeInOutQuad', position(), to - position(), move, callback );
};

//+++++++++++++++++++++++++++++++++++++++++++++++
// BACK TO TOP
//+++++++++++++++++++++++++++++++++++++++++++++++
// This class just scrolls the content
// back to top
//+++++++++++++++++++++++++++++++++++++++++++++++

/*
CC.BackToTop = function(button) {
  this.button = button;
  this.button.addEventListener('click', this.backToTopClicked);
};

CC.BackToTop.prototype.backToTopClicked = function(ev) {
  ev.preventDefault();
  CC.scrollTo(0, null, 500);
  ev.target.blur();
}*/

//+++++++++++++++++++++++++++++++++++++++++++++++
// ScrollToSection
//+++++++++++++++++++++++++++++++++++++++++++++++
// This class consists of a link (probably
// inside a navigation) and a target, to which
// the window should scroll on click
//+++++++++++++++++++++++++++++++++++++++++++++++

// Constructor
DW.ScrollToSection = function(link, target) {
  this.link = link;
  this.target = typeof target !== 'undefined' ? target : document.querySelector(this.link.href.substr(this.link.href.indexOf('#')));
  this.link.addEventListener('click', this.scrollToTarget.bind(this));
};

// Methods
DW.ScrollToSection.prototype = {
  scrollToTarget : function(ev) {
    ev.preventDefault();
    var distance = this.target.offsetTop - window.pageYOffset;
    distance = distance < 0 ? distance * -1 : distance; // make sure it's a positive value
    distance = Math.min(500, distance / 3); // make sure it's not longer than 500
    DW.scrollTo(this.target.offsetTop, null, distance);
    ev.target.blur();
  },
};

DW.LoadingTransitions = function(initOnLoadObjects) {
	this.loaded = false;
	this.unload = true;
	this.exceptionFromUnloadHrefs = [
		'mailto:',
		'tel:'
	];
	this.timoutLoad = null;

	// All objects that need some logic to happen on load
	this.initOnLoadObjects = initOnLoadObjects;

  // unload event get's also called by mail, tel, etc. Links and should be stopped for those
  this.exceptionFromUnloadHrefs = [
    'mailto:',
    'tel:'
  ];

	// Indicate loading, either on window.load or after 2500ms
	timeoutLoad = setTimeout(this.loadContent.bind(this), 2500);
	window.addEventListener('load', this.loadContent.bind(this));

	// add Unload Event Listener
	window.addEventListener('beforeunload', this.unloadContent.bind(this));

  // exception Listener
	document.addEventListener('click', this.checkIfUnloadShouldHappen.bind(this));
};

DW.LoadingTransitions.prototype = {
	loadContent: function() {

		// this should happen only once
		clearTimeout(this.timeoutLoad);
		if(this.loaded === false) {
			this.loaded = true;
			document.body.classList.add("loaded");

			// Tell objects, load has happened
			setTimeout(function() {
				this.initOnLoadObjects.forEach(function(initOnLoadObject) {
					initOnLoadObject.initOnLoad();
				});
			}.bind(this), 300);
		}
	},

	unloadContent: function() {
		if(this.unload === true) {
			document.body.classList.add("unload");
		}

		// Reset unload
		unload = true;
	},

  checkIfUnloadShouldHappen: function(ev) {
    
    // Check if unload should be canceled for link
		if(typeof ev.target.href !== 'undefined') {
			this.exceptionFromUnloadHrefs.forEach(function(exceptionFromUnloadHref) {
				if(ev.target.href.indexOf(exceptionFromUnloadHref) >= 0) {
					this.unload = false;
				}
			}.bind(this));
		}
  }
};


(function() {

	var mainMenu,
	scrollEvents,
	contactMenu,
	loaded = false,
	unload = true,
	timoutLoad;

	function domLoaded() {
		objectFitImages();

		mainMenu = new DW.MainMenu(document.querySelector('.menu-container'), document.querySelectorAll('.jump-to--menu'));

		scrollEvents = new DW.ScrollEvents(document.querySelectorAll('.svg-top-container, .svg-bottom-container'), document.querySelectorAll('.timeline-figure'), document.querySelectorAll('.even-block, .odd-block, .page-preview, .block-team'), document.querySelector('[role="banner"]'));

		contactMenu = new DW.ContactMenu(document.querySelector('.contact-container');

		var accordions = [].slice.call(document.querySelectorAll('.accordion'));
		accordions.forEach(function(accordion) {
			new DW.Accordion(accordion, accordion.querySelector('.accordion-body'), accordion.querySelector('.button--accordion-toggle'), accordion.querySelector('.button--accordion-toggle-close'));
		});

		var navSectionsLinks = [].slice.call(document.querySelectorAll('.nav-sections-link, .feature-image-disturber'));
		navSectionsLinks.forEach(function(elem) {
			new DW.ScrollToSection(elem);
		});

		new DW.LoadingTransitions([scrollEvents]);
	}

	// unload event get's also called by mail, tel, etc. Links and should be stopped for those
	var exceptionFromUnloadHrefs = [
		'mailto:',
		'tel:'
	];

	document.addEventListener('click', function(ev) {

		// Check if unload should be canceled for link
		if(typeof ev.target.href !== 'undefined') {
			exceptionFromUnloadHrefs.forEach(function(exceptionFromUnloadHref) {
				if(ev.target.href.indexOf(exceptionFromUnloadHref) >= 0) {
					unload = false;
				}
			});
		}
	});


	// DomContentLoaded might have already happened, when this script is loaded (async)
	if(pageLoaded === true) {
		domLoaded();
	} else {
		// modern document ready state (IE9+). Immediately makes sure, that only modern browsers are able to do this
		document.addEventListener('DOMContentLoaded', domLoaded);
	}

})();
